import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { ActivatedRoute } from '@angular/router';
import { Component, OnInit, ViewContainerRef } from '@angular/core';
import { AngularFirestore, AngularFirestoreCollection, AngularFirestoreDocument } from '@angular/fire/firestore';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
@Component({
  selector: 'app-ticket-single',
  templateUrl: './ticket-single.component.html',
  styleUrls: ['./ticket-single.component.css']
})
export class TicketSingleComponent implements OnInit {
  id: any;
  singleticket: any;
  messages: any;
  message: any;
  closed: any = false;
  constructor(private afs: AngularFirestore, private route: ActivatedRoute,
    public toastr: ToastsManager, vcr: ViewContainerRef
  ) {
    this.toastr.setRootViewContainerRef(vcr);
    this.route.params.subscribe(params => {
      this.id = params['id'];
    });
  }

  async ngOnInit() {
    const ticketdetails = await this.afs.doc('tickets/' + this.id).valueChanges();
    ticketdetails.subscribe(data => {
      this.singleticket = data;
      this.closed = data['closed'];
      this.getmessages(this.id);
    });
  }
  async send() {
   if (!this.message) {
     return false;
   }
    this.afs.collection('messages').add({ ticketid: this.id, createdAt: new Date().toString(), message: this.message, addedby: 'webnnel' });
    this.getmessages(this.id);
    await this.afs.doc(`tickets/${this.id}`).update({ usernewmsg: true });
    this.message = '';
  }
  async getmessages(id) {
    try {
      const message = await this.afs.collection('messages', res => {
        return res.where('ticketid', '==', id).orderBy('createdAt');
      }).valueChanges();
      message.subscribe(data => {
        this.messages = data;
        if (this.singleticket.usernewmsg) {
          this.afs.doc(`tickets/${this.id}`).update({ usernewmsg: false });
        }
      });
    } catch (error) {
      console.log(error);
    }
  }
  closeticket() {
    this.afs.doc('tickets/' + this.id).update({closed: true});
    this.toastr.success('Ticket closed successfully', 'Success');
    this.closed = true;
  }
}



// WEBPACK FOOTER //
// ./src/app/Ticket/ticket-single/ticket-single.component.ts